import { useState } from "react";
import axios from "axios";
import { useToast } from "@/hooks/use-toast";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const classOptions = [
  "Baby Swimming (8wks–18m)",
  "Tiddler & Pre-school (18m–4y)",
  "Children's lessons (4y+)",
  "Adult lessons",
  "Adult social swim",
  "Not sure yet",
];
export const dayOptions = ["Mon", "Tue", "Wed", "Thu", "Fri", "Sat", "Sun"];
export const heardFromOptions = ["Google", "Facebook", "Instagram", "ChatGPT", "Referral", "Recommendation", "Village magazine", "Other"];
export const childrenOptions = [
  ["1", "1 child"],
  ["2", "2 children"],
  ["3", "3 children"],
  ["4+", "4 or more children"],
  ["Adult (just me)", "Adult lessons — just me"],
];

export const isReferral = (h) => h === "Referral" || h === "Recommendation";

const emptyForm = { name: "", email: "", phone: "", children: "", classes: [], days: [], heardFrom: "", referredBy: "", message: "", website: "" };

// Form state + submission for the contact/enquiry form.
export function useContactForm() {
  const { toast } = useToast();
  const [form, setForm] = useState(emptyForm);
  const [loading, setLoading] = useState(false);

  const update = (k) => (e) => setForm((f) => ({ ...f, [k]: e.target.value }));
  const toggleIn = (k, val) => setForm((f) => ({
    ...f,
    [k]: f[k].includes(val) ? f[k].filter((v) => v !== val) : [...f[k], val],
  }));

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await axios.post(`${API}/contact`, {
        name: form.name,
        email: form.email,
        phone: form.phone,
        children: form.children,
        classes: form.classes,
        days: form.days,
        heard_from: form.heardFrom,
        referred_by: isReferral(form.heardFrom) ? form.referredBy : "",
        message: form.message,
        website: form.website,
      });
      toast({ title: "Enquiry sent! 🧡", description: "Thanks — we'll be in touch very soon." });
      setForm(emptyForm);
    } catch (err) {
      console.error("Contact form submission failed", err);
      if (err?.response?.status === 429) {
        toast({ title: "Whoa, that's a lot of splashing!", description: "You've sent a few enquiries in a short time — please try again in a little while, or call us on 01582 883820.", variant: "destructive" });
      } else {
        toast({ title: "Something went wrong", description: "Please try again, or call us on 01582 883820.", variant: "destructive" });
      }
    } finally {
      setLoading(false);
    }
  };

  return { form, loading, update, toggleIn, submit };
}
